import {
  TVerificationAppElement,
  VerificationAppDocumentType,
} from "../../app/models";
import { TDocument } from "../models";

const IDENTIFICATION_DOC_TYPES: VerificationAppDocumentType[] = [
  VerificationAppDocumentType.Passport,
  VerificationAppDocumentType.Id,
  VerificationAppDocumentType.Selfie,
];

export type QuestionnaireStepMatch = {
  element: TVerificationAppElement;
  documents: TDocument[];
};

export type QuestionnaireDocumentMatchResult = {
  stepDocuments: QuestionnaireStepMatch[];
  orphanDocuments: TDocument[];
};

export function effectiveStepDocumentType(
  stepConfig: TVerificationAppElement
): string {
  return stepConfig.name?.trim() ? stepConfig.name : stepConfig.type;
}

export function getQuestionnaireDocumentTypes(
  stepConfig: TVerificationAppElement
): string[] {
  switch (stepConfig.type) {
    case VerificationAppDocumentType.Identification:
      return IDENTIFICATION_DOC_TYPES;
    default:
      return [effectiveStepDocumentType(stepConfig)];
  }
}

export function matchQuestionnaireDocuments(
  elements: TVerificationAppElement[] | null | undefined,
  documents: TDocument[] | null | undefined
): QuestionnaireDocumentMatchResult {
  const sourceDocuments = documents ?? [];

  if (!elements || elements.length === 0) {
    return {
      stepDocuments: [],
      orphanDocuments: sourceDocuments,
    };
  }

  const stepDocuments = elements.map((element) => {
    const documentTypes = getQuestionnaireDocumentTypes(element);
    const matchedDocuments = sourceDocuments.filter((document) =>
      documentTypes.includes(document.document.documentType)
    );

    return {
      element,
      documents: matchedDocuments,
    };
  });

  const matchedIds = new Set(
    stepDocuments.flatMap(({ documents: matchedDocuments }) =>
      matchedDocuments.map((document) => document.document.documentId)
    )
  );

  return {
    stepDocuments,
    orphanDocuments: sourceDocuments.filter(
      (document) => !matchedIds.has(document.document.documentId)
    ),
  };
}
